import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2.2, viewBox: "0 0 24 24", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 5v14m-7-7h14" }));
export default SvgPlus;
